import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import './cam-context-switcher-menu-list';
import './cam-context-switcher-card-list';

const tagName = 'cam-context-switcher-panel';
const template = require(`../templates/${tagName}.ejs`);
const template_workspaces = require(`../templates/cam-context-switcher-tab-workspaces.ejs`);
const template_costcenters = require(`../templates/cam-context-switcher-tab-costcenters.ejs`);
const template_favorites = require(`../templates/cam-context-switcher-tab-favorites.ejs`);
const template_organizations = require(`../templates/cam-context-switcher-tab-organizations.ejs`);

import searchIcon from '../../assets/images/icons/Vector_search_icon.svg';
import { eventMenuItemClicked } from './cam-context-switcher-constants';

export default class CamContextSwitcherPanel extends HTMLElement {

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
    this.panelData = {
      searchIcon: searchIcon
    };
  }

  connectedCallback() {
    this.id = tagName;
    this.classList.add(tagName);
    // resets search context datastore to null
    this.datastore.filter = null;
    this.innerHTML = template(this.panelData);
    this.setupTab('favorite');
    this.setupTab('organization');
    this.setupTab('workspace');
    this.setupTab('costcenter');

    this.handleTabClicked(this.datastore.selectedTab);
    this.renderPanel();

    let search = document.querySelector('#search-button');
    search.focus();
    search.oninput = (e) => {
      this.datastore.filter = e.target.value;
      this.renderPanel();
    };
    document.addEventListener(eventMenuItemClicked, this.handleMenuItemClicked.bind(this));
  }

  setupTab(tabName){
    let me = this;

    let tab = document.querySelector(`#cam-context-switcher-${tabName}-tab`);
    if(this.datastore.config.enabledContexts.includes(tabName)) {
      tab.classList.remove('disabled');
      tab.onclick = function() {
        me.handleTabClicked(tabName);
      };
    } else {
      tab.classList.add('disabled');
    }
  }


  disconnectedCallback() {
    document.removeEventListener(eventMenuItemClicked, this.handleMenuItemClicked.bind(this));
  }

  renderPanel() {
    this.datastore.updateAllContexts();
    this.renderList('favorite', 'card', this.datastore.favorites);

    this.renderList('organization', 'card', this.datastore.organizations);
    this.renderList('organization', 'menu', this.datastore.organizations);

    this.renderList('costcenter', 'card', this.datastore.costcenters);
    this.renderList('costcenter', 'menu', this.datastore.costcenters);

    this.renderList('workspace', 'card', this.datastore.workspaces);
  }

  renderList(name, type, data){
    let list = document.querySelector(`#cam-context-switcher-${name}-${type}-list`);
    if (list){
      if(type === 'card'){
        list.renderCamCardList(data);
      } else {
        list.renderMenuItemList(data);
      }
    }
  }

  handleMenuItemClicked(e) {
    e.cancelBubble = true;
    this.datastore.changeFilterScope(e.detail.context);
    this.renderPanel();
  }

  handleTabClicked(tabName) {
    this.datastore.selectedTab = tabName;

    let tabs = document.querySelector('#cam-context-switcher-tabs');
    tabs.innerHTML = '';
    if(tabName === 'favorite') {
      tabs.innerHTML = template_favorites();
    } else if(tabName === 'organization') {
      tabs.innerHTML = template_organizations();
    } else if(tabName === 'costcenter') {
      tabs.innerHTML = template_costcenters();
    } else {
      tabs.innerHTML = template_workspaces();
    }

    let tabContainer = document.querySelector('#cam-context-switcher-tab-container').childNodes;
    tabContainer.forEach((node) => {
      if(node.tagName === 'A') {
        if(node.id.indexOf(tabName) > -1){
          node.setAttribute('selected', true);
        } else {
          node.removeAttribute('selected');
        }
      }
    });

    this.renderPanel();

  }
}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcherPanel);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-panel.js